import { OccConfig } from '@spartacus/core';

export const searchProductOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        searchProduct:
          'products/search?fields=products(code,name,completeName,summary,configurable,configuratorType,multidimensional,price(FULL),yourPrice,differencePrice,images(DEFAULT),stock(FULL),averageRating,variantOptions,discontinued,catalogNumber,partNumber,keySpecs,customerPartNumber,topCategory,substituteProduct),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery',
      } as any,
    },
  },
};
